import { truncateText } from 'utils/truncateText';

export const highlightPartialMatch = (text: string, match: string) => {
  const lowerText = text.toLowerCase();
  const lowerMatch = match.toLowerCase();
  const matchIndex = lowerText.indexOf(lowerMatch);

  if (matchIndex === -1) {
    return truncateText(text);
  }

  const beforeMatch = text.substring(0, matchIndex);
  const matchText = text.substring(matchIndex, matchIndex + match.length);
  const afterMatch = text.substring(matchIndex + match.length);

  return (
    <>
      {truncateText(beforeMatch)}
      <b className="highlightedResult" data-testid="highlightedResult">
        {truncateText(matchText)}
      </b>
      {truncateText(afterMatch)}
    </>
  );
};
